import { jsx, jsxs } from 'react/jsx-runtime';
import { useCallback } from 'react';
import { SelectList } from '../../SelectList/SelectList.es.js';
import { useMenuContext } from '../Menu.Context/index.es.js';

const MenuItem = ({ className, item, inactive = false, disabled, truncate = true, handleSelect, children, ...rest })=>{
    const [{ role }, { setOpen }] = useMenuContext();
    const onSelect = useCallback(()=>{
        handleSelect?.(item);
        setOpen(false);
    }, [
        handleSelect,
        item,
        setOpen
    ]);
    if (inactive) {
        return null;
    }
    if (item?.header) {
        return jsx(SelectList.Item.Header, {
            "data-testid": "list-item-header",
            disabled: true,
            children: item.label
        });
    }
    return jsxs(SelectList.Item, {
        "data-testid": "list-item",
        disabled: disabled,
        handleSelect: onSelect,
        item: item,
        role: role === 'menu' ? 'menuitem' : 'option',
        truncate: truncate,
        ...rest,
        children: [
            jsx(SelectList.Item.Description, {
                children: item?.description
            }),
            jsx(SelectList.Item.Icon, {
                align: "left",
                name: item?.icon
            }),
            jsx(SelectList.Item.Icon, {
                align: "right",
                name: item?.tagIcon
            }),
            jsx(SelectList.Item.Tag, {
                align: "right",
                children: item?.tag
            })
        ]
    });
};
MenuItem.displayName = 'MenuV2.Item';

export { MenuItem };
//# sourceMappingURL=Menu.Item.es.js.map
